/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { ContactDto } from '../models/contact-dto';
import { PurchaseContactsResultDto } from '../models/purchase-contacts-result-dto';
import { PurchasedContactDto } from '../models/purchased-contact-dto';

@Injectable({
  providedIn: 'root',
})
export class ContactService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation loadContact
   */
  static readonly LoadContactPath = '/contacts/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `loadContact()` instead.
   *
   * This method doesn't expect any request body.
   */
  loadContact$Response(params: {
    id: string;
  }): Observable<StrictHttpResponse<ContactDto>> {

    const rb = new RequestBuilder(this.rootUrl, ContactService.LoadContactPath, 'get');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ContactDto>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `loadContact$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  loadContact(params: {
    id: string;
  }): Observable<ContactDto> {

    return this.loadContact$Response(params).pipe(
      map((r: StrictHttpResponse<ContactDto>) => r.body as ContactDto)
    );
  }

  /**
   * Path part for operation loadContact1
   */
  static readonly LoadContact1Path = '/contacts/email/{email}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `loadContact1()` instead.
   *
   * This method doesn't expect any request body.
   */
  loadContact1$Response(params: {
    email: string;
  }): Observable<StrictHttpResponse<ContactDto>> {

    const rb = new RequestBuilder(this.rootUrl, ContactService.LoadContact1Path, 'get');
    if (params) {
      rb.path('email', params.email, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ContactDto>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `loadContact1$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  loadContact1(params: {
    email: string;
  }): Observable<ContactDto> {

    return this.loadContact1$Response(params).pipe(
      map((r: StrictHttpResponse<ContactDto>) => r.body as ContactDto)
    );
  }

  /**
   * Path part for operation getPurchasedContact
   */
  static readonly GetPurchasedContactPath = '/contacts/{id}/purchase';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getPurchasedContact()` instead.
   *
   * This method doesn't expect any request body.
   */
  getPurchasedContact$Response(params: {
    id: string;
  }): Observable<StrictHttpResponse<PurchasedContactDto>> {

    const rb = new RequestBuilder(this.rootUrl, ContactService.GetPurchasedContactPath, 'get');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<PurchasedContactDto>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getPurchasedContact$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getPurchasedContact(params: {
    id: string;
  }): Observable<PurchasedContactDto> {

    return this.getPurchasedContact$Response(params).pipe(
      map((r: StrictHttpResponse<PurchasedContactDto>) => r.body as PurchasedContactDto)
    );
  }

  /**
   * Path part for operation purchaseContact
   */
  static readonly PurchaseContactPath = '/contacts/{id}/purchase';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `purchaseContact()` instead.
   *
   * This method doesn't expect any request body.
   */
  purchaseContact$Response(params: {
    id: string;
  }): Observable<StrictHttpResponse<PurchaseContactsResultDto>> {

    const rb = new RequestBuilder(this.rootUrl, ContactService.PurchaseContactPath, 'post');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<PurchaseContactsResultDto>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `purchaseContact$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  purchaseContact(params: {
    id: string;
  }): Observable<PurchaseContactsResultDto> {

    return this.purchaseContact$Response(params).pipe(
      map((r: StrictHttpResponse<PurchaseContactsResultDto>) => r.body as PurchaseContactsResultDto)
    );
  }

  /**
   * Path part for operation purchaseContacts
   */
  static readonly PurchaseContactsPath = '/contacts/purchase';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `purchaseContacts()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  purchaseContacts$Response(params: {
    body: Array<string>
  }): Observable<StrictHttpResponse<PurchaseContactsResultDto>> {

    const rb = new RequestBuilder(this.rootUrl, ContactService.PurchaseContactsPath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<PurchaseContactsResultDto>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `purchaseContacts$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  purchaseContacts(params: {
    body: Array<string>
  }): Observable<PurchaseContactsResultDto> {

    return this.purchaseContacts$Response(params).pipe(
      map((r: StrictHttpResponse<PurchaseContactsResultDto>) => r.body as PurchaseContactsResultDto)
    );
  }

  /**
   * Path part for operation updateContactTags
   */
  static readonly UpdateContactTagsPath = '/contacts/{id}/tags';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateContactTags()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateContactTags$Response(params: {
    id: string;
    body?: Array<string>
  }): Observable<StrictHttpResponse<void>> {

    const rb = new RequestBuilder(this.rootUrl, ContactService.UpdateContactTagsPath, 'put');
    if (params) {
      rb.path('id', params.id, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: '*/*'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `updateContactTags$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateContactTags(params: {
    id: string;
    body?: Array<string>
  }): Observable<void> {

    return this.updateContactTags$Response(params).pipe(
      map((r: StrictHttpResponse<void>) => r.body as void)
    );
  }

}
